<template>
  <div>
    <vs-card class="p-4">
      <!-- Popup -->
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <div class="flex gap-2">
              <label class="vs-input--label block">Privacy Policy</label>
              <vx-tooltip text="View Privacy Policy" v-if="preview_privacy_policy">
                <feather-icon icon="EyeIcon" @click="openPdf(preview_privacy_policy)" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
              </vx-tooltip>
            </div>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="privacy_policy"
              ref="files"
              accept=".pdf"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              @change="handlePdfUpload($event, 'privacy_policy')"
              data-vv-as="Privacy Policy"
            />
            <span class="text-danger text-sm" v-show="errors.has('privacy_policy')">{{ errors.first('privacy_policy') }}</span>
          </div>
          <div class="vx-col w-1/2">
            <div class="flex gap-2">
              <label class="vs-input--label block">Terms & Conditions</label>
              <vx-tooltip text="View Terms & Conditions" v-if="preview_terms_conditions">
                <feather-icon icon="EyeIcon" @click="openPdf(preview_terms_conditions)" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
              </vx-tooltip>
            </div>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="terms_conditions"
              ref="files"
              accept=".pdf"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              @change="handlePdfUpload($event, 'terms_conditions')"
              data-vv-as="Terms & Conditions"
            />
            <span class="text-danger text-sm" v-show="errors.has('terms_conditions')">{{ errors.first('terms_conditions') }}</span>
          </div>
          <div class="vx-col w-full cursor-pointer mt-3">
            <label class="vs-input--label block">About Us *</label>
            <quill-editor v-model="form.about_us" name="about_us" v-validate="'required|exclude_special_char'" data-vv-as="About Us" class="custom-quill-editor"></quill-editor>
          </div>
          <span class="text-danger text-sm mt-12 ml-4" v-show="errors.has('about_us')">{{ errors.first('about_us') }}</span>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 mt-12 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="update-setting" @click="save_changes">Update</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  /** Page Name */
  name: `SettingAction`,

  components: {
    quillEditor
  },

  /** data */
  data() {
    return {
      form: {
        privacy_policy: null,
        terms_conditions: null,
        about_us: null
      },
      preview_privacy_policy: null,
      preview_terms_conditions: null
    }
  },

  /** created */
  async created() {
    this.getData()
  },
  /** computed */
  computed: {
    ...mapState('setting', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  /** methods */
  methods: {
    ...mapActions('setting', {
      update: 'update',
      get: 'get'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const data = new FormData()

        if (this.form.privacy_policy) {
          data.append('privacy_policy', this.form.privacy_policy)
        }
        if (this.form.terms_conditions) {
          data.append('terms_conditions', this.form.terms_conditions)
        }
        data.append('about_us', this.form.about_us)
        const { message } = await this.update(data)
        this.getData()
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.isActive = false
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    async getData() {
      const { data } = await this.get()

      if (data) {
        this.preview_privacy_policy = data.privacy_policy ? data.privacy_policy : null
        this.preview_terms_conditions = data.terms_conditions ? data.terms_conditions : null
        this.form.about_us = data.about_us ? data.about_us : null
      }
    },

    openPdf(url) {
      window.open(url, '_blank')
    },

    handlePdfUpload(e, type) {
      const file = e.target.files[0]
      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      this.form[type] = file
    }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#update-setting',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-setting > .con-vs-loading')
      }
    }
  }
}
</script>
<style scoped>
.custom-quill-editor {
  height: 400px;
}
</style>
